module.exports = __webpack_public_path__ + "static/media/16UNODC22.02b3e787.jpg";